import { createReducer } from '@reduxjs/toolkit';
import { GET_BILLS } from '../actions/bills';

// TODO: infer type from docs
export type BillsState = {
  bills: {
    rows: unknown[];
    pagination: {
      current: number;
      per_page: number;
    };
  };
};

const initialState: BillsState = {
  bills: {
    rows: [],
    pagination: {
      current: 1,
      per_page: 30,
    },
  },
};

const billsReducer = createReducer(initialState, (builder) =>
  builder.addCase(GET_BILLS, (state, action) => {
    return { ...state, ...action.payload };
  })
);

export default billsReducer;
